import type { MessageKey } from "./ru"

export const taMessages = {
  "common.loading": "ஏற்றப்படுகிறது...",
  "common.error": "பிழை",
  "common.back": "பின்",
  "common.next": "அடுத்து",
  "common.search": "தேடல்",
  "auth.loginErrorTitle": "உள்நுழைவு பிழை",
  "auth.openViaTelegram": "Telegram மூலம் பயன்பாட்டைத் திறக்கவும்",
  "auth.telegramRequired": "பயன்பாடு Telegram மூலம் திறக்கப்பட வேண்டும்",
  "auth.authorizationError": "அங்கீகார பிழை",
  "device.rotatePortrait": "சாதனத்தை செங்குத்தாக மாற்றவும்",
  "country.brazil": "பிரேசில்",
  "country.vietnam": "வியட்நாம்",
  "country.egypt": "எகிப்து",
  "country.india": "இந்தியா",
  "country.indonesia": "இந்தோனேசியா",
  "country.iran": "ஈரான்",
  "country.spain": "ஸ்பெயின்",
  "country.italy": "இத்தாலி",
  "country.kazakhstan": "கசகஸ்தான்",
  "country.colombia": "கொலம்பியா",
  "country.malaysia": "மலேசியா",
  "country.mexico": "மெக்சிகோ",
  "country.nigeria": "நைஜீரியா",
  "country.pakistan": "பாகிஸ்தான்",
  "country.russia": "ரஷ்யா",
  "country.usa": "அமெரிக்கா",
  "country.turkey": "துருக்கி",
  "country.uzbekistan": "உஸ்பெகிஸ்தான்",
  "country.ukraine": "உக்ரைன்",
  "country.philippines": "பிலிப்பைன்ஸ்",
  "countrySelection.chooseCountry": "நாட்டைத் தேர்ந்தெடுக்கவும்",
  "countrySelection.openAria": "நாட்டைத் தேர்ந்தெடுக்கவும்",
  "languageSelection.chooseLanguage": "மொழியைத் தேர்ந்தெடுக்கவும்",
  "commercial.direction.autotrade": "வாகன சந்தை",
  "commercial.direction.insurance": "காப்பீடு",
  "commercial.direction.pitstop": "Pit Stop",
  "commercial.direction.techhelp": "சாலை உதவி",
  "commercial.searchLabel": "BeepApp தேடல்",
  "commercial.cityPlaceholder": "நகரத்தை உள்ளிடவும்",
  "commercial.emptyTitle": "இன்று சலுகைகள் இல்லை",
  "commercial.emptyLine1": "உங்கள் நகரத்தில் இன்னும் செயல்படும் BeepApp கூட்டாளர்கள் இல்லை",
  "commercial.emptyLine2": "அவர்களை கண்டுபிடித்து இணைக்கும் பணியில் நாங்கள் ஏற்கனவே உள்ளோம்",
  "commercial.emptyLine3": "புதிய சலுகைகள் இங்கே தானாக தோன்றும்",
  "commercial.helperLine1": "கிடைக்கும் சலுகைகளைப் பார்க்க",
  "commercial.helperLine2": "உங்கள் நகரத்தை உள்ளிடவும்",
  "commercial.partnerPrompt": "BeepApp கூட்டாளராக விரும்புகிறீர்களா?",
  "commercial.apply": "விண்ணப்பிக்கவும்",
  "main.admin": "நிர்வாகம்",
  "main.garage": "Garage",
  "main.signalSent": "சிக்னல் அனுப்பப்பட்டது",
  "main.partnerInviteUnavailable": "கூட்டாளர் அழைப்பு கிடைக்கவில்லை",
  "main.enterPlate": "வாகன எண் பலகையை உள்ளிடவும்",
  "main.searchError": "தேடல் பிழை",
  "main.signalSendError": "சிக்னலை அனுப்ப முடியவில்லை",
  "main.shareCardPrefix": "எண் பலகை அட்டை",
  "main.shareLinkError": "இணைப்பைத் தயாரிக்க முடியவில்லை",
  "main.searchByPlateAria": "எண் பலகையால் தேடவும்",
  "main.russianPlateAria": "ரஷ்ய எண் பலகை",
  "main.plateAria": "வாகன எண் பலகை",
  "main.findPlateAria": "எண் பலகையை கண்டுபிடிக்கவும்",
  "main.loadingVehicle": "எண் பலகை அட்டை ஏற்றப்படுகிறது…",
  "main.leaveSignal": "சிக்னல் அனுப்பவும்",
  "main.share": "பகிரவும்",
  "signalSelection.chooseType": "சிக்னல் வகையைத் தேர்ந்தெடுக்கவும்",
  "signalSelection.category.attention": "தனிப்பட்ட",
  "signalSelection.category.road": "சாலை",
  "signalSelection.category.urgent": "அவசரம்",
  "signalSelection.chooseSignal": "சிக்னலைத் தேர்ந்தெடுக்கவும்",
  "signalSelection.suggestOwn": "உங்கள் விருப்பத்தை பரிந்துரைக்கவும்",
  "signalConfirmation.title": "சிக்னலை உறுதிப்படுத்தவும்",
  "signalConfirmation.plateHeading": "வாகன எண் பலகையைச் சரிபார்க்கவும்",
  "signalConfirmation.signalHeading": "தேர்ந்தெடுத்த சிக்னலைச் சரிபார்க்கவும்",
  "signalConfirmation.replyTitle": "Telegram-ல் பதிலளிக்க அனுமதிக்கவும்",
  "signalConfirmation.replyBody": "இதனை இயக்கினால் எண் பலகை உரிமையாளர்\nTelegram மூலம் உங்களுக்கு எழுதலாம். உங்களிடம்\n@username இருந்தால் மட்டுமே பதில் சாத்தியம். பதிலளிக்கும் முடிவு\nஎண் பலகை உரிமையாளரிடமே இருக்கும்.",
  "signalConfirmation.consentText": "இந்த சிக்னல் உண்மையான சூழலைக் குறிக்கிறது என்றும்\nஇது spam அல்லது பொய்யான புகார் அல்ல என்றும்\nநான் உறுதிப்படுத்துகிறேன்.",
  "signalConfirmation.warning": "அனுப்பிய பிறகு சிக்னலை\nமாற்ற முடியாது",
  "signalConfirmation.sending": "அனுப்பப்படுகிறது…",
  "signalConfirmation.send": "அனுப்பவும்",
  "partner.loadingAria": "ஏற்றப்படுகிறது",
  "partner.title": "கூட்டாளர் திட்டம்",
  "partner.offerLine1": "நீங்கள் BeepApp-க்கு அழைக்கும் பயனர்களின் அனைத்து கட்டணங்களிலிருந்தும்",
  "partner.offerLine2": "காலவரையறையின்றி 30% பெறுங்கள்",
  "partner.offerLine3": "Telegram Affiliate மூலம்",
  "partner.connectUnavailable": "Telegram Affiliate திட்டம் அமைக்கப்பட்ட பிறகு இணைப்பு கிடைக்கும்.",
  "partner.connectTelegram": "Telegram-ல் இணைக்கவும்",
  "partner.qrAria": "கூட்டாளர் இணைப்பு QR குறியீடு",
  "partner.download": "பதிவிறக்கவும்",
  "partner.promoHeading": "தனிப்பட்ட promo code உருவாக்கவும்",
  "partner.promoHelperLine1": "Promo code கூடுதல் ஒரு ஆண்டு சந்தாவை செயல்படுத்தும்",
  "partner.promoHelperLine2": "மேலும் பயனர்களை ஈர்க்க உதவும்",
  "partner.promoAria": "Promo code",
  "partner.affiliateHeading": "உங்கள் கூட்டாளர் இணைப்பு",
  "partner.affiliateHelper": "தனிப்பட்ட QR குறியீட்டை உருவாக்க இணைப்பைச் சேமிக்கவும்",
  "partner.affiliateAria": "கூட்டாளர் இணைப்பு",
  "partner.qrNoteLine1": "QR குறியீட்டை உங்கள் வாகனத்தில்,",
  "partner.qrNoteLine2": "சமூக வலைதளங்களிலும் விளம்பரப் பொருட்களிலும் வைக்கலாம்",
  "partner.save": "சேமிக்கவும்",
  "partner.reset": "மீட்டமைக்கவும்",
  "partner.resetConfirm": "சேமித்த கூட்டாளர் இணைப்பை மீட்டமைக்கவா? Promo code உங்களிடமே இருக்கும்.",
  "partner.promoFormatError": "Promo code 4 முதல் 15 எழுத்துகள் இருக்க வேண்டும்.",
  "partner.affiliateHostError": "t.me அல்லது telegram.me இணைப்புகள் மட்டுமே அனுமதிக்கப்படும்.",
  "partner.affiliatePathError": "இணைப்பில் Telegram பாதை இல்லை.",
  "partner.affiliateFormatError": "தவறான கூட்டாளர் இணைப்பு.",
  "partner.loadError": "ஏற்றுதல் பிழை",
  "partner.checkInputError": "உள்ளிட்ட தகவலைச் சரிபார்க்கவும்",
  "garageActivation.promoInvalid": "Promo code தவறானது",
  "garageActivation.plateOccupied": "இந்த எண் பலகை ஏற்கனவே இணைக்கப்பட்டுள்ளது",
  "garageActivation.activateError": "Garage-ஐ செயல்படுத்த முடியவில்லை",
  "garageEntry.loadJournalError": "பதிவேட்டை ஏற்ற முடியவில்லை",
  "garageEntry.loadStatusesError": "நிலைகளை ஏற்ற முடியவில்லை",
  "garageEntry.activationSuccess": "Garage வெற்றிகரமாக செயல்படுத்தப்பட்டது",
  "garageEntry.plateAttached": "எண் பலகை இணைக்கப்பட்டது",
  "garageEntry.attachError": "எண் பலகையை இணைக்க முடியவில்லை",
  "garageEntry.activationNote": "உங்கள் Garage-ஐ செயல்படுத்தவும்",
  "garageSheet.activationTitle": "Garage செயல்படுத்தல்",
  "garageSheet.plateHelper": "வாகன எண் பலகையை உள்ளிடவும்",
  "garageSheet.promoHelper": "உங்களிடம் promo code உள்ளதா?",
  "garageSheet.cleanBonusLine1": "செயல்படுத்திய பிறகு 1 மணி நேரம்",
  "garageSheet.cleanBonusLine2": "இலவச “Clean Start” கிடைக்கும்",
  "garageSheet.activationFor": "செயல்பாட்டு காலம்",
  "garageSheet.cost": "விலை",
  "garageSheet.ownerConsentLine1": "குறிப்பிட்ட எண் பலகையுள்ள",
  "garageSheet.ownerConsentLine2": "வாகனத்தின் உரிமையாளர் நான்",
  "garageSheet.ownerConsentLine3": "என்று உறுதிப்படுத்துகிறேன்.",
  "garageSheet.processing": "செயலாக்கப்படுகிறது...",
  "garageSheet.attach": "இணைக்கவும்",
  "garageSheet.pay": "செலுத்தவும்",
  "garageLifecycle.cleanTitle": "Clean Start",
  "garageLifecycle.deactivateTitle": "Garage செயலிழக்கச் செய்தல்",
  "garageLifecycle.cleanWarningLine1": "எண் பலகை வரலாறு நீக்கப்படும்",
  "garageLifecycle.cleanWarningLine2": "அதை மீட்டெடுக்க முடியாது!",
  "garageLifecycle.deactivateWarningLine1": "செயலிழக்கச் செய்த பிறகு செயலில் உள்ள",
  "garageLifecycle.deactivateWarningLine2": "Garage அம்சங்களுக்கான அணுகல் முடியும்",
  "garageLifecycle.willBeDeleted": "நீக்கப்படும்",
  "garageLifecycle.cleanRemovedLine1": "• பதிவேட்டின் அனைத்து பதிவுகளும்",
  "garageLifecycle.cleanRemovedLine2": "• பெறப்பட்ட சிக்னல் வரலாறு",
  "garageLifecycle.cleanRemovedLine3": "• எண் பலகை அட்டையின் பொது",
  "garageLifecycle.cleanRemovedLine4": "  சிக்னல் எண்ணிக்கைகள்",
  "garageLifecycle.willRemain": "தொடரும்",
  "garageLifecycle.cleanPreservedLine1": "• Garage-க்கு எண் பலகை இணைப்பு",
  "garageLifecycle.cleanPreservedLine2": "• மீதமுள்ள செயல்பாட்டு காலம்",
  "garageLifecycle.cleanPreservedLine3": "• தேர்ந்தெடுத்த எண் பலகை நிலை",
  "garageLifecycle.cleanPreservedLine4": "• எண் பலகை அட்டையின் மொத்த பார்வைகள்",
  "garageLifecycle.freeFirstHour": "முதல் மணி நேரத்தில் இலவசம்",
  "garageLifecycle.willBecomeUnavailable": "கிடைக்காது",
  "garageLifecycle.deactivateRemovedLine1": "• பதிவேடு",
  "garageLifecycle.deactivateRemovedLine2": "• எண் பலகை நிலையைத் தேர்வு செய்து பயன்படுத்துதல்",
  "garageLifecycle.deactivateRemovedLine3": "• நீங்கள் AutoClan-இலிருந்து தானாக வெளியேறுவீர்கள்",
  "garageLifecycle.deactivateRemovedLine4": "• வாகன சந்தை",
  "garageLifecycle.deactivateRemovedLine5": "• காப்பீடு",
  "garageLifecycle.deactivateRemovedLine6": "• Pit Stop",
  "garageLifecycle.deactivateRemovedLine7": "• சாலை உதவி",
  "garageLifecycle.deactivateRemovedLine8": "• எண் பலகை Garage-இலிருந்து துண்டிக்கப்படும்",
  "garageLifecycle.willRemainAvailable": "கிடைத்துக்கொண்டே இருக்கும்",
  "garageLifecycle.deactivatePreservedLine1": "• Companion",
  "garageLifecycle.deactivatePreservedLine2": "• Dispatcher",
  "garageLifecycle.deactivatePreservedLine3": "• எண் பலகை தேடலும்",
  "garageLifecycle.deactivatePreservedLine4": "  பொது வாகன அட்டையைப் பார்ப்பதும்",
  "garageLifecycle.deactivatePreservedLine5": "• எந்த நேரத்திலும் Garage-ஐ",
  "garageLifecycle.deactivatePreservedLine6": "  மீண்டும் செயல்படுத்தும் வசதி",
  "garageLifecycle.cleanConsentLine1": "இந்த எண் பலகையின் முழு வரலாற்றையும்",
  "garageLifecycle.cleanConsentLine2": "மீட்டெடுக்க முடியாதவாறு நீக்க",
  "garageLifecycle.cleanConsentLine3": "நான் ஒப்புக்கொள்கிறேன்.",
  "garageLifecycle.deactivateConsentLine1": "செயலிழக்கச் செய்வதையும் அனைத்து செயலில் உள்ள",
  "garageLifecycle.deactivateConsentLine2": "Garage அம்சங்களுக்கான அணுகலை",
  "garageLifecycle.deactivateConsentLine3": "முடிப்பதையும் உறுதிப்படுத்துகிறேன்.",
  "garageLifecycle.clean": "நீக்கவும்",
  "garageLifecycle.deactivate": "செயலிழக்கச் செய்யவும்",
} satisfies Record<MessageKey, string>
